import sectionCollapsibleProductGridCss from '../css-snippets/section-collapsible-product-grid';

const html = `
<style>${sectionCollapsibleProductGridCss}</style>
  <div
  class="collapsible-product-grid collapsible-product-grid-unique-id"
  data-id="unique-id"
  data-attribute="section-container"
  data-section="collapsible-product-grid"
  data-title="Collapsible Product Grid"
  data-see-more-text="see more"
  data-see-less-text="see less"
  data-top-padding="true"
  data-bottom-padding="true"
>
  <div class="container">
    <h2 class="collapsible-product-grid-title" data-attribute="section-title">
      Beneficial Against Multiple Health Issues
    </h2>
    <div
      class="collapsible-product-grid-content"
      data-attribute="section-description"
    >
      With the help of top chiropractors & a team of medical professionals, it
      took us 3 years and $193,000 in laboratory tests to develop the Hugterra™
      Belt, and it's proven to help against the most common health issues, such
      as:
    </div>
    <div
      class="collapsible-product-grid-list"
      data-attribute="grid-items-container"
    >
      <div class="collapsible-product-grid-item" data-attribute="grid-item">
        <div class="collapsible-product-grid-item-head">
          <div class="collapsible-product-grid-item-meta">
            <img
              class="collapsible-product-grid-item-image"
              loading="lazy"
              data-attribute="item-image"
              src="https://cdn.skyfastimg.com/images/2025/09/23/image-68d2739e30c5b0662beeb1bd.png?w=50&h=50&q=80"
              alt="product-image"
            />
            <h3
              class="collapsible-product-grid-item-title"
              data-attribute="item-title"
            >
              Sciatica
            </h3>
          </div>
          <div class="collapsible-product-grid-item-button" type="button">
            <span
              class="collapsible-product-grid-item-button-text"
              data-attribute="see-more-text"
              >see more</span
            >
            <span class="collapsible-product-grid-item-button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.043"
                height="7.602"
                viewBox="0 0 10.043 7.602"
              >
                <path
                  id="Union_19"
                  data-name="Union 19"
                  d="M8.428,0a.386.386,0,0,0-.315.167L4.922,4.8,1.91.177A.381.381,0,0,0,1.589,0H.384A.379.379,0,0,0,.05.2.379.379,0,0,0,.056.586L4.285,7.422a.387.387,0,0,0,.328.18h.533a.376.376,0,0,0,.318-.17L9.979.6A.387.387,0,0,0,9.658,0Z"
                  fill="#000000"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.042"
                height="7.602"
                viewBox="0 0 10.042 7.602"
              >
                <path
                  id="Union_17"
                  data-name="Union 17"
                  d="M11.428,7.6a.382.382,0,0,1-.315-.167L7.922,2.8,4.911,7.427a.381.381,0,0,1-.322.177h-1.2a.384.384,0,0,1-.328-.586L7.285.182A.385.385,0,0,1,7.61,0h.533a.382.382,0,0,1,.322.17L12.979,7A.389.389,0,0,1,13,7.4a.384.384,0,0,1-.337.2Z"
                  transform="translate(-3 -0.002)"
                  fill="#000000"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div
          class="collapsible-product-grid-item-content"
          data-attribute="item-content"
        >
          <p>
            The belt applies targeted compression and deep infrared heat to
            reduce inflammation around the sciatic nerve, instantly relieving
            sharp, radiating leg pain.
          </p>
        </div>
      </div>

      <div class="collapsible-product-grid-item" data-attribute="grid-item">
        <div class="collapsible-product-grid-item-head">
          <div class="collapsible-product-grid-item-meta">
            <img
              class="collapsible-product-grid-item-image"
              loading="lazy"
              data-attribute="item-image"
              src="https://cdn.skyfastimg.com/images/2025/09/23/image-68d273bee32689950d486c20.png?w=50&h=50&q=80"
              alt="product-image"
            />
            <h3
              class="collapsible-product-grid-item-title"
              data-attribute="item-title"
            >
              Lower Back pain
            </h3>
          </div>
          <div class="collapsible-product-grid-item-button" type="button">
            <span
              class="collapsible-product-grid-item-button-text"
              data-attribute="see-more-text"
              >see more</span
            >
            <span class="collapsible-product-grid-item-button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.043"
                height="7.602"
                viewBox="0 0 10.043 7.602"
              >
                <path
                  id="Union_19"
                  data-name="Union 19"
                  d="M8.428,0a.386.386,0,0,0-.315.167L4.922,4.8,1.91.177A.381.381,0,0,0,1.589,0H.384A.379.379,0,0,0,.05.2.379.379,0,0,0,.056.586L4.285,7.422a.387.387,0,0,0,.328.18h.533a.376.376,0,0,0,.318-.17L9.979.6A.387.387,0,0,0,9.658,0Z"
                  fill="#000000"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.042"
                height="7.602"
                viewBox="0 0 10.042 7.602"
              >
                <path
                  id="Union_17"
                  data-name="Union 17"
                  d="M11.428,7.6a.382.382,0,0,1-.315-.167L7.922,2.8,4.911,7.427a.381.381,0,0,1-.322.177h-1.2a.384.384,0,0,1-.328-.586L7.285.182A.385.385,0,0,1,7.61,0h.533a.382.382,0,0,1,.322.17L12.979,7A.389.389,0,0,1,13,7.4a.384.384,0,0,1-.337.2Z"
                  transform="translate(-3 -0.002)"
                  fill="#000000"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div
          class="collapsible-product-grid-item-content"
          data-attribute="item-content"
        >
          <p>
            Combining heat, massage, and spinal support, the belt decompresses
            the spine and relaxes tight lower back muscles — easing chronic
            aches and restoring mobility.
          </p>
        </div>
      </div>

      <div class="collapsible-product-grid-item" data-attribute="grid-item">
        <div class="collapsible-product-grid-item-head">
          <div class="collapsible-product-grid-item-meta">
            <img
              class="collapsible-product-grid-item-image"
              loading="lazy"
              data-attribute="item-image"
              src="https://cdn.skyfastimg.com/images/2025/09/23/image-68d273d2948604064d51c149.png?w=50&h=50&q=80"
              alt="product-image"
            />
            <h3
              class="collapsible-product-grid-item-title"
              data-attribute="item-title"
            >
              Calf Pain
            </h3>
          </div>
          <div class="collapsible-product-grid-item-button" type="button">
            <span
              class="collapsible-product-grid-item-button-text"
              data-attribute="see-more-text"
              >see more</span
            >
            <span class="collapsible-product-grid-item-button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.043"
                height="7.602"
                viewBox="0 0 10.043 7.602"
              >
                <path
                  id="Union_19"
                  data-name="Union 19"
                  d="M8.428,0a.386.386,0,0,0-.315.167L4.922,4.8,1.91.177A.381.381,0,0,0,1.589,0H.384A.379.379,0,0,0,.05.2.379.379,0,0,0,.056.586L4.285,7.422a.387.387,0,0,0,.328.18h.533a.376.376,0,0,0,.318-.17L9.979.6A.387.387,0,0,0,9.658,0Z"
                  fill="#000000"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.042"
                height="7.602"
                viewBox="0 0 10.042 7.602"
              >
                <path
                  id="Union_17"
                  data-name="Union 17"
                  d="M11.428,7.6a.382.382,0,0,1-.315-.167L7.922,2.8,4.911,7.427a.381.381,0,0,1-.322.177h-1.2a.384.384,0,0,1-.328-.586L7.285.182A.385.385,0,0,1,7.61,0h.533a.382.382,0,0,1,.322.17L12.979,7A.389.389,0,0,1,13,7.4a.384.384,0,0,1-.337.2Z"
                  transform="translate(-3 -0.002)"
                  fill="#000000"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div
          class="collapsible-product-grid-item-content"
          data-attribute="item-content"
        >
          <p>
            Sciatica often sends pain down to the calves. By targeting the nerve
            root in the lower back, the belt helps reduce referred calf pain at
            its origin.
          </p>
        </div>
      </div>

      <div class="collapsible-product-grid-item" data-attribute="grid-item">
        <div class="collapsible-product-grid-item-head">
          <div class="collapsible-product-grid-item-meta">
            <img
              class="collapsible-product-grid-item-image"
              loading="lazy"
              data-attribute="item-image"
              src="https://cdn.skyfastimg.com/images/2025/09/23/image-68d273e371893a0bea33f131.png?w=50&h=50&q=80"
              alt="product-image"
            />
            <h3
              class="collapsible-product-grid-item-title"
              data-attribute="item-title"
            >
              Thigh Pain
            </h3>
          </div>
          <div class="collapsible-product-grid-item-button" type="button">
            <span
              class="collapsible-product-grid-item-button-text"
              data-attribute="see-more-text"
              >see more</span
            >
            <span class="collapsible-product-grid-item-button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.043"
                height="7.602"
                viewBox="0 0 10.043 7.602"
              >
                <path
                  id="Union_19"
                  data-name="Union 19"
                  d="M8.428,0a.386.386,0,0,0-.315.167L4.922,4.8,1.91.177A.381.381,0,0,0,1.589,0H.384A.379.379,0,0,0,.05.2.379.379,0,0,0,.056.586L4.285,7.422a.387.387,0,0,0,.328.18h.533a.376.376,0,0,0,.318-.17L9.979.6A.387.387,0,0,0,9.658,0Z"
                  fill="#000000"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.042"
                height="7.602"
                viewBox="0 0 10.042 7.602"
              >
                <path
                  id="Union_17"
                  data-name="Union 17"
                  d="M11.428,7.6a.382.382,0,0,1-.315-.167L7.922,2.8,4.911,7.427a.381.381,0,0,1-.322.177h-1.2a.384.384,0,0,1-.328-.586L7.285.182A.385.385,0,0,1,7.61,0h.533a.382.382,0,0,1,.322.17L12.979,7A.389.389,0,0,1,13,7.4a.384.384,0,0,1-.337.2Z"
                  transform="translate(-3 -0.002)"
                  fill="#000000"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div
          class="collapsible-product-grid-item-content"
          data-attribute="item-content"
        >
          <p>
            When lower spine nerves are compressed, thigh pain can follow. The
            belt relieves pressure from these nerves to ease burning, tingling,
            or numbness in the upper leg.
          </p>
        </div>
      </div>

      <div class="collapsible-product-grid-item" data-attribute="grid-item">
        <div class="collapsible-product-grid-item-head">
          <div class="collapsible-product-grid-item-meta">
            <img
              class="collapsible-product-grid-item-image"
              loading="lazy"
              data-attribute="item-image"
              src="	https://cdn.skyfastimg.com/images/2025/09/23/image-68d2740505d2db4c9bddfe7b.png?w=50&h=50&q=80"
              alt="product-image"
            />
            <h3
              class="collapsible-product-grid-item-title"
              data-attribute="item-title"
            >
              Buttocks/Groin Pain
            </h3>
          </div>
          <div class="collapsible-product-grid-item-button" type="button">
            <span
              class="collapsible-product-grid-item-button-text"
              data-attribute="see-more-text"
              >see more</span
            >
            <span class="collapsible-product-grid-item-button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.043"
                height="7.602"
                viewBox="0 0 10.043 7.602"
              >
                <path
                  id="Union_19"
                  data-name="Union 19"
                  d="M8.428,0a.386.386,0,0,0-.315.167L4.922,4.8,1.91.177A.381.381,0,0,0,1.589,0H.384A.379.379,0,0,0,.05.2.379.379,0,0,0,.056.586L4.285,7.422a.387.387,0,0,0,.328.18h.533a.376.376,0,0,0,.318-.17L9.979.6A.387.387,0,0,0,9.658,0Z"
                  fill="#000000"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.042"
                height="7.602"
                viewBox="0 0 10.042 7.602"
              >
                <path
                  id="Union_17"
                  data-name="Union 17"
                  d="M11.428,7.6a.382.382,0,0,1-.315-.167L7.922,2.8,4.911,7.427a.381.381,0,0,1-.322.177h-1.2a.384.384,0,0,1-.328-.586L7.285.182A.385.385,0,0,1,7.61,0h.533a.382.382,0,0,1,.322.17L12.979,7A.389.389,0,0,1,13,7.4a.384.384,0,0,1-.337.2Z"
                  transform="translate(-3 -0.002)"
                  fill="#000000"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div
          class="collapsible-product-grid-item-content"
          data-attribute="item-content"
        >
          <p>
            Tight muscles and compressed discs can send pain to the buttocks or
            groin. The Hugterra Belt helps release this pressure and restore
            normal nerve function.
          </p>
        </div>
      </div>

      <div class="collapsible-product-grid-item" data-attribute="grid-item">
        <div class="collapsible-product-grid-item-head">
          <div class="collapsible-product-grid-item-meta">
            <img
              class="collapsible-product-grid-item-image"
              loading="lazy"
              data-attribute="item-image"
              src="https://cdn.skyfastimg.com/images/2025/09/23/image-68d27413d3ab741930caa36d.png?w=50&h=50&q=80"
              alt="product-image"
            />
            <h3
              class="collapsible-product-grid-item-title"
              data-attribute="item-title"
            >
              Stress Relief
            </h3>
          </div>
          <div class="collapsible-product-grid-item-button" type="button">
            <span
              class="collapsible-product-grid-item-button-text"
              data-attribute="see-more-text"
              >see more</span
            >
            <span class="collapsible-product-grid-item-button-icon">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.043"
                height="7.602"
                viewBox="0 0 10.043 7.602"
              >
                <path
                  id="Union_19"
                  data-name="Union 19"
                  d="M8.428,0a.386.386,0,0,0-.315.167L4.922,4.8,1.91.177A.381.381,0,0,0,1.589,0H.384A.379.379,0,0,0,.05.2.379.379,0,0,0,.056.586L4.285,7.422a.387.387,0,0,0,.328.18h.533a.376.376,0,0,0,.318-.17L9.979.6A.387.387,0,0,0,9.658,0Z"
                  fill="#000000"
                ></path>
              </svg>
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="10.042"
                height="7.602"
                viewBox="0 0 10.042 7.602"
              >
                <path
                  id="Union_17"
                  data-name="Union 17"
                  d="M11.428,7.6a.382.382,0,0,1-.315-.167L7.922,2.8,4.911,7.427a.381.381,0,0,1-.322.177h-1.2a.384.384,0,0,1-.328-.586L7.285.182A.385.385,0,0,1,7.61,0h.533a.382.382,0,0,1,.322.17L12.979,7A.389.389,0,0,1,13,7.4a.384.384,0,0,1-.337.2Z"
                  transform="translate(-3 -0.002)"
                  fill="#000000"
                ></path>
              </svg>
            </span>
          </div>
        </div>
        <div
          class="collapsible-product-grid-item-content"
          data-attribute="item-content"
        >
          <p>
            Pain causes stress — and stress worsens pain. The belt’s soothing
            massage and warmth create a calming effect, relaxing both your
            muscles and your mind.
          </p>
        </div>
      </div>
    </div>
  </div>
</div>

`;
export default html;
